<div class="modal-header">
    <h3 class="modal-title">Controls at the Bottom</h3>
</div>
<div class="modal-body">
    Use the buttons at the bottom of your screen.
    <div class="center animated bounce infinite aqua">
        <fa-icon [icon]="['fas','arrow-down']"></fa-icon>
    </div>
</div>